import React, { useContext } from "react";
import styles from "./BuildingTabs.module.css";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import { needCertificateEngText } from "../../../Utility/engLangObject";
import { needCertificateGerText } from "../../../Utility/gerLangObject";
import { selectedLanguage } from "../../../Utility/helper";
function BuildingTabs({ type, setType = () => {}, ...props }) {
  const { state } = useContext(AppContext);
  const {language} = state
  return (
    <div>
      <div className={styles.itemContainer}>
        {buildingData.map((item, index) => {
          return (
            <div
              className={`${styles.itemTitle} ${
                item.id === type && styles.itemTitleActive
              }`}
              onClick={() => setType(item.id)}
            >
             {selectedLanguage(item, language)}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BuildingTabs;
const buildingData = [
  {
    title: needCertificateEngText.type_roof,
    german_title: needCertificateGerText.type_roof,
    id: 1,
  },
  {
    title: needCertificateEngText.type_window,
    german_title: needCertificateGerText.type_window,
    id: 2,
  },
  {
    title: needCertificateEngText.type_basement,
    german_title: needCertificateGerText.type_basement,
    id: 3,
  },
  {
    title: needCertificateEngText.type_insulation,
    german_title: needCertificateGerText.type_insulation,
    id: 4,
  },
];
